/*
 * @Author: your name
 * @Date: 2021-08-30 16:50:44
 * @LastEditTime: 2021-10-21 14:43:05
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\workshopApproval\service\service.js
 */
import utils from '@src/common/utils'
export function getDatas({workNo="", workShopName="", name="", pageNum = 1, pageSize = 10, self= undefined, caller = undefined}) {
  const params = {
    'pageNum': pageNum,
    'pageSize': pageSize,
    'workNo': workNo,
    'workShopName': workShopName,
    'name': name,
  }
  self.$fetch('vas/appointment/queryWorkshopApplyRecordList.json', params).then((response) => {
    caller(response)
  })
}


